class r {
  buffer;
  currentOffset;
  constructor(t) {
    this.buffer = t, this.currentOffset = 0;
  }
  static withSize(t) {
    const e = new Uint8Array(t);
    return new r(e);
  }
  extend(t) {
    const e = this.currentOffset + t.length;
    if (e > this.buffer.byteLength) {
      const f = this.buffer;
      this.buffer = new Uint8Array(e * 2), this.buffer.set(f);
    }
    this.buffer.set(t, this.currentOffset), this.currentOffset += t.length;
  }
  reset() {
    this.currentOffset = 0;
  }
  view(t = !1) {
    const e = this.buffer.subarray(0, this.currentOffset);
    return t ? e.slice() : e;
  }
  size() {
    return this.currentOffset;
  }
}
export {
  r as default
};
//# sourceMappingURL=SmartVec.js.map
